// Render fragment for of — the entity's GraphQL display contract.
// Scaffolded once from the @medplum/definitions reverse projection; hand-curate
// freely to match what the view renders (this file is owned, not generated).
import { graphql } from '@eluve/graphql-fhir';

/**
 * Everything a Medication view (or the generic fallback) could render.
 * Compose into queries: graphql(`query { ... ...MedicationRender }`, [MedicationRenderFragment]).
 * References are terminal ({ reference type display }) — expand nested
 * `resource` selections in the query when resolved targets are needed.
 */
export const MedicationRenderFragment = graphql(`
  fragment MedicationRender on Medication @_unmask {
    resourceType
    id
    meta {
      versionId
      lastUpdated
      profile
      tag {
        system
        code
      }
      security {
        system
        code
        display
      }
    }
    modifierExtension {
      url
    }
    identifier {
      use
      system
      value
    }
    code {
      text
      coding {
        system
        code
        display
      }
    }
    status
    manufacturer {
      reference
      type
      display
    }
    form {
      text
      coding {
        system
        code
        display
      }
    }
    amount {
      numerator {
        value
        comparator
        unit
        system
        code
      }
      denominator {
        value
        comparator
        unit
        system
        code
      }
    }
    ingredient {
      itemCodeableConcept {
        text
        coding {
          system
          code
          display
        }
      }
      itemReference {
        reference
        type
        display
      }
      isActive
      strength {
        numerator {
          value
          comparator
          unit
          system
          code
        }
        denominator {
          value
          comparator
          unit
          system
          code
        }
      }
    }
    batch {
      lotNumber
      expirationDate
    }
  }
`);
